import React from 'react'
import { AllCardsType } from '../../../data/all-cards'
import { randomNumberInRange } from '../../../utils/functions'
import { useWidth } from '../../../hooks/useWidth'

const PhotoCards = ({ cards, mazo, tapiz }: { cards: AllCardsType[]; mazo: string; tapiz: string }) => {
    const width = useWidth()
    const translate = width >= 1280 ? 10 : 5
    const row1 = cards.slice(0, 4)
    const row2 = cards.slice(4, 7)

    const renderCard = (card: AllCardsType, index: number) => (
        <img
            key={index}
            src={require('../../../assets/' + mazo + card.url + '/' + card.image)}
            className={
                card.url === 'mayores'
                    ? 'w-[9vw] h-auto mini:rounded-sm xl:rounded-[10px] box-shadow-[5px_5px_2px_rgba(0,0,0,1)]'
                    : 'bg-white w-[9vw] h-auto mini:rounded-sm xl:rounded-[10px] box-shadow-[5px_5px_2px_rgba(0,0,0,1)]'
            }
            style={{
                transform:
                    'rotate(' +
                    `${
                        card.position !== 'invertida'
                            ? randomNumberInRange(-5, 5)
                            : randomNumberInRange(175, 185)
                    }` +
                    'deg) translateY(' +
                    randomNumberInRange(-translate, translate) +
                    'px',
            }}
            alt=""
        />
    )

    return (
        <div className="relative mini:w-[80vw] mini:h-[52vw] xl:w-[65vw] xl:h-[44vw] after:bg-white-gradient after:absolute after:w-full after:h-full after:z-20 after:top-0 after-left-0 overflow-hidden">
            <div
                className="absolute inset-[-240px] bg-cover"
                style={{
                    transform: `rotate(${randomNumberInRange(-5, 5)}deg) translateY(${
                        randomNumberInRange(-40, 40) + 'px'
                    }) translateX(${randomNumberInRange(-40, 40) + 'px'})`,
                    backgroundImage: `url(/fondos/${tapiz}.jpg)`,
                }}
            ></div>
            <div className="relative flex flex-col items-center justify-center w-full h-full gap-3 mini:px-4 mini:py-10 xl:px-8 xl:py-14">
                <div className="flex items-center justify-center gap-2 xl:gap-4">
                    {row1.map((card, index) => renderCard(card, index))}
                </div>
                <div className="flex items-center justify-center gap-2 xl:gap-4">
                    {row2.map((card, index) => renderCard(card, index + 4))}
                </div>
            </div>
        </div>
    )
}

export default PhotoCards
